import react from "react";

import shoe2 from "../images/commercials/WeAreShoe/KIDSPORTFOLIO_WITHBORDERS_2024_032 Large.jpeg";
import shoe3 from "../images/commercials/WeAreShoe/KIDSPORTFOLIO_WITHBORDERS_2024_033 Large.jpeg";
import shoe4 from "../images/commercials/WeAreShoe/KIDSPORTFOLIO_WITHBORDERS_2024_034 Large.jpeg";
import shoe5 from "../images/commercials/WeAreShoe/73_SHOE_06 Large.jpeg"

const WeAreShoe = () => {
    return (

        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={shoe2} alt="We Are Shoe - Image 2"/>
                </div>
                <div className="single portrait">
                    <img src={shoe3} alt="We Are Shoe - Image 3"/>
                </div>
                <div className="single portrait">
                    <img src={shoe4} alt="We Are Shoe - Image 4"/>
                </div>
                <div className="single portrait">
                    <img src={shoe5} alt="We Are Shoe - Image 5"/>
                </div>
            </div>
        </div>
    );
}

export default WeAreShoe;